import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const BookingOverview = ({ data }) => {
    const chartData = [
        { name: 'Completed', value: data.completedBookings, color: '#4CAF50' },
        { name: 'Pending', value: data.pendingBookings, color: '#FFC107' },
        { name: 'In Progress', value: data.totalBookings - data.completedBookings - data.pendingBookings, color: '#2196F3' },
    ];

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                <h5 className="mb-0">Booking Status</h5>
            </div>
            <div className="card-body d-flex flex-column">
                <div style={{ height: '220px' }} className="mb-3">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={chartData}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value) => [`${value} bookings`, 'Count']} />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                
                <div className="mt-auto">
                    <div className="row g-3">
                        {chartData.map((item, index) => (
                            <div key={index} className="col-4">
                                <div className="p-3 rounded" style={{ backgroundColor: `${item.color}20` }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="me-2" style={{ width: '10px', height: '10px', backgroundColor: item.color, borderRadius: '50%' }}></div>
                                        <span className="small">{item.name}</span>
                                    </div>
                                    <h5 className="mb-0">{item.value}</h5>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingOverview;